import { account } from '~/store/account'

export default defineNuxtRouteMiddleware(async to => {
    // The verify email change page should also be accessible when user is logged in
    if (!to.fullPath.includes('/confirm-email-change')) {
        const localePath = useLocalePath()
        const token = account().accountToken
        if (token) {
            return navigateTo(localePath('/account'))
        }
    }
})
